import axios from 'axios'
import {loginFn} from '../assets/js/common'
import {getAccessToken, setToken} from './auth'

// 创建axios实例
const http = axios.create({
  timeout: 35000, // 请求超时时间
  withCredentials: true, // 跨域
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  }
})

// request拦截器
http.interceptors.request.use(config => {
  // 默认请求参数
  const defaultParams = {}
  // 设置租户id
  // config.headers['tenant-id'] = getTenantId() // 让每个请求携带租户id 请根据实际情况自行修改
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  if (getAccessToken() && !isToken) {
    config.headers['Authorization'] = getAccessToken() // 让每个请求携带自定义token
  }
  if (config.method === 'post') {
    if (config.headers['Content-Type'] === 'application/json;charset=UTF-8') {
      config.data = {
        ...defaultParams,
        ...config.data
      }
    }
  } else if (config.method === 'get') {

  }
  console.log('请求参数', config, '请求地址', config.url)
  return config
}, error => {
  Promise.reject(error)
})

// response拦截器
http.interceptors.response.use(
  response => {
    // 续期token
    if (response.headers.refreshtoken && response.headers.refreshtoken !== undefined && response.headers.refreshtoken !== null) {
      setToken(response.headers.refreshtoken)
    }

    var newdata = '' // 返回的数据
    newdata = response.data
    console.log('响应内容', newdata, '响应地址：', response.config.url)
    if (newdata !== '') {
      if (newdata.code === 401) {
        // token过期，重新登录
        loginFn()
      } else {
        return newdata
      }
    }
  },
  error => {
    return Promise.reject(error)
  })

export default http



// WEBPACK FOOTER //
// ./src/util/request.js